<template>
  <div ref="addFeeTaxesDialogContainer">
    <ed-modal
      :show="show"
      :title="title"
      primary-button="Save"
      secondary-button="Cancel"
      @close="onClose"
      @validate="onSave"
      :validation="validation"
      :closeOnEsc="true"
      name='allocate_cost_center_popup'
    >
      <div slot="body">
        <section class="col-md-10 no-pad">
          Allocate to Cost Center for the following items:
          <ul v-for="item in selectedItemNames" :key="item">
            <li>{{item}}</li>
          </ul>
          <div class="row col-md-10 no-pad">
            <ed-select
              field-label="Cost Center"
              placeholder="Select a Cost Center"
              :options="costCenters"
              required="required"
              label="name"
              track-by="code"
              :customLabel='getCostCenterName'
              v-model="formData.draftItem.selectedCostCenter"
              @select="costCenterSelected($event)"
              :error="doDisplayCostCenterError"
              :helptip-header="doDisplayCostCenterError && 'Error' || ''"
              :helptip-body="doDisplayCostCenterError && 'Please select a Cost Center' || ''"
              name='allocate_to_cost_centers'
            />
          </div>
        </section>
        <div class="clear"></div>
      </div>
    </ed-modal>
  </div>
</template>

<script>

import LineItemStore from './LineItemStore.js'
import { EventBus } from '@/event-bus'

export default {
  name: 'AllocateToCC',

  props: {
    model: Object,
    eventHub: Object,
    dependencies: Object,
    eventUniqueId: String
  },

  data() {
    return {
      formData: {
        draftItem: {
          selectedCostCenter: {}
        }
      },
      show: true,
      title: 'Allocate to Cost Center',
      validation: true,
      costCenters: [],
      selectedRows: [],
      selectedItemNames: [],
      doDisplayCostCenterError: false
    }
  },

  created() {
    var dialog = this
    this.title = 'Allocate to Cost Center'
    this.selectedRows = this.model.selectedRows
    this.selectedItemNames = this.model.selectedRows.map(item => {
      return item.data.name
    })

    this.store()
      .getCostCentersBusinessUnits(
        this.model.programId
      )
      .then(response => {
        dialog.bindCostCenters(response.data)
      })
  },

  methods: {
    getCostCenterName(option) {
      return option.name
        ? option.name.indexOf(option.code) === -1
          ? option.code + ' (' + option.name + ')'
          : option.name
        : option.code
    },

    costCenterSelected(e) {
      this.formData.draftItem.selectedCostCenter = {
        code: e.code,
        name: e.name,
        key: e.key
      }
      this.doDisplayCostCenterError = false
    },

    store() {
      return new LineItemStore(this.api)
    },

    onClose() {
      this.show = false
    },

    onSave() {
      if (!this.isValid()) return

      EventBus.$emit('onSaveAllocateToCC', {
        data: {
          costCenter: this.formData.draftItem.selectedCostCenter,
          itemsToUpdate: this.selectedRows.map(item => { return item.rowIndex }),
          eventUniqueId: this.eventUniqueId
        }
      })
      this.$nextTick(() => {
        this.show = false
      })
    },

    isValid() {
      if (this.formData.draftItem.selectedCostCenter &&
        JSON.stringify(this.formData.draftItem.selectedCostCenter) !== JSON.stringify({}) &&
        this.formData.draftItem.selectedCostCenter.key &&
        this.formData.draftItem.selectedCostCenter.name) {
        this.doDisplayCostCenterError = false
        return true
      }

      this.doDisplayCostCenterError = true
      return false
    },

    bindCostCenters(data) {
      var costCenters = data.costCentersAndBusinessUnit.costCenters

      if (costCenters !== null && costCenters !== undefined && costCenters.length > 0) {
        this.costCenters = costCenters

        if (this.selectedRows.length === 1) {
          let selectedCC = this.selectedRows[0].data.costCenterAndBusinessUnit
          let cc = {
            key: selectedCC.costCenterNo,
            name: selectedCC.costCenterName
          }
          cc.code = costCenters.filter(item => item.name === selectedCC.costCenterName && item.key === selectedCC.costCenterNo)[0].code || ''

          this.formData.draftItem.selectedCostCenter = {
            key: cc.key,
            name: cc.name,
            code: cc.code
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/I2P/dialogs/LineItem/AllocateToCC.vue